<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps } from 'vue';

/*==================================================================*/
/*=============== COMPONENTES IMPORTS ==============================*/
/*==================================================================*/

import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import TabelaBase from '@/components/v2/base/TabelaBase/TabelaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    dado: {
        type: Object,
        default: () => ({})
    },
    aprovadoresParaExibicao: {
        type: Array,
        default: () => ([])
    }
});

/*==================================================================*/
/*================== COR DA DECISÃO ================================*/
/*==================================================================*/

const corDecisao = (dado = {}) => {

    if(dado?.decisao === 'Aprovou'){
        return 'green';
    }

    if(dado?.decisao === 'Reprovou'){
        return 'red';
    }

    return 'gray';

};

/*==================================================================*/
/*================== ÍCONE DA DECISÃO ==============================*/
/*==================================================================*/

const iconeDecisao = (dado = {}) => {

    if(dado?.decisao === 'Aprovou'){
        return 'mdi-check-circle';
    }

    if(dado?.decisao === 'Reprovou'){
        return 'mdi-close-circle';
    }

    return 'mdi-circle';

};

/*==================================================================*/
/*================== HEADERS DA TABELA =============================*/
/*==================================================================*/

const aprovadoresHeaders = [
    { text: 'Código', value: 'codigo', type: 'string' },
    { text: 'Tipo de Aprovador', value: 'aprovadorTipo', type: 'string' },
    { text: 'Aprovador', value: 'aprovador.nome', type: 'string' },
    { text: 'Decisão', value: 'decisao', type: 'string' },
    { text: 'Data da Decisão', value: 'dataDecisao', type: 'date' },
    { text: 'Justificativa', value: 'justificativa', type: 'textarea' },
];

</script>

<template>

    <CartaoBase>

        <template #header>

            <div class="c-header">

                <span class="c-header__titulo">Aprovadores</span>

            </div>

        </template>

        <template #body>

            <TabelaBase
                :headers="aprovadoresHeaders"
                :dados="props.aprovadoresParaExibicao"
            >

                <template #linha-item.decisao="{ dado }">

                    <v-icon :color="corDecisao(dado)" large>
                        {{ iconeDecisao(dado) }}
                    </v-icon>

                </template>

            </TabelaBase>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Card ==========================================*/
/*==================================================================*/

.c-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 600;
}

</style>
